// Move wishlist icon next to add-to-cart button in mobile view
if (window.matchMedia("(max-width: 767px)").matches) {
 var wlElem = document.querySelector(".product-gallery .swym-wishlist-button-bar"),
   elem = wlElem.cloneNode(true);
 document.querySelector(".buy-buttons").append(elem);
 document.querySelector(".product-gallery .swym-wishlist-button-bar").remove();
}